<script setup lang="ts">
const props = defineProps<{ 
    title: string,
    desc: string,
    items: Array<{
        title: string,
        desc: string,
        img: string
    }>,
}>();
</script>

<template>
    <SectionsBase id="launch-steps" class="bg-grad">
        <div class="container">
            <ChipsDivider>راه‌اندازی</ChipsDivider>
            <h2>{{ props.title }}</h2>
            <p class="text-body1-semibold text-gray-400 text-center my-6">{{ props.desc }}</p>
            <div class="flex flex-col lg:flex-row items-center lg:items-start lg:justify-center lg:mb-16 lg:mt-0">
                <div 
                    v-for="item, index in props.items"
                    :key="item.title"
                    class="relative w-82.5 flex lg:flex-col gap-14 lg:gap-4 items-center py-8 lg:py-16"
                >
                    <div class="flex-center">
                        <span 
                            class="step-ind"
                            :class="[
                                index === 0 && 'mr-5',
                                index === 1 && 'mr-2',
                            ]"
                        >
                            {{ index + 1 }}
                        </span>
                        <div v-if="index !== 0" class="dashed-line right" />
                        <NuxtImg 
                            :src="item.img"
                            :alt="item.title"
                            width="80"
                            class="relative z-2 min-w-14 w-14 lg:w-20 bg-white"
                            loading="lazy"
                            data-aos="flip-right" 
                            data-aos-duration="1000"
                            :data-aos-delay="index * 300"
                        />
                        <div v-if="index !== props.items.length - 1" class="dashed-line left" />
                    </div>
                    <div 
                        class="flex flex-col lg:items-center relative z-1 pr-2 lg:pr-0"
                        data-aos="flip-right" 
                        data-aos-duration="1000"
                        :data-aos-delay="index * 300"
                    >
                        <h3 class="mb-2 text-body1-semibold">{{ item.title }}</h3>
                        <p class="max-w-65 lg:max-w-full text-gray-400 text-body2 lg:text-center">{{ item.desc }}</p>
                    </div>
                </div>
            </div>
        </div>
    </SectionsBase>
</template>

<style scoped>
@reference "~/assets/css/main.css";
.bg-grad {
  background: url('/img/new/backgrounds/dashed-01.webp'), linear-gradient(
    to bottom, 
    var(--color-secondary-100), 
    white 25%, 
    white 75%, 
    var(--color-secondary-100)
  );
}

.step-ind {
    text-shadow:
        -1px -1px 0 var(--color-secondary-400),
        1px -1px 0 var(--color-secondary-400),
        -1px  1px 0 var(--color-secondary-400),
        1px  1px 0 var(--color-secondary-400);
    @apply
    absolute right-15 bg-clip-text text-[5rem] text-white font-bold select-none
    lg:right-0 lg:text-[10rem]
}
.dashed-line {
    @apply
    absolute w-0 h-1/2 border-r-[3px] border-dashed z-0 border-gray-400
    lg:w-1/2 lg:h-0 lg:border-r-0 lg:border-t-[3px]
}
.dashed-line::before {
    @apply
    content-[''] absolute w-0.75 h-full top-0 -right-0.75 bg-linear-to-b
    lg:bg-linear-to-r lg:w-full lg:h-0.75 lg:-top-0.75 lg:left-0
}
.dashed-line.left::before {
    @apply
    from-white to-transparent
    lg:from-transparent lg:to-white
}
.dashed-line.right::before {
    @apply
    from-transparent to-white
    lg:from-white lg:to-transparent
}
.dashed-line.left {
    @apply
    right-7 bottom-[1.5px]
    lg:left-[1.5px] lg:right-auto lg:bottom-auto
}
.dashed-line.right {
    @apply
    right-7 top-[1.5px]
    lg:right-[1.5px] lg:top-auto
}
</style>